import { render, staticRenderFns } from "./UbButton.vue?vue&type=template&id=1e8b9368&"
import script from "./UbButton.vue?vue&type=script&lang=js&"
export * from "./UbButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports